import React from "react";

const PredefinedThemesList = ({ predefinedThemes, selectedTheme, onSelect }) => {
  return (
    <div className="card shadow-sm border-0 rounded-4 p-4 mb-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="fw-semibold mb-0">Predefined Themes</h5>
        <span className="text-muted small">{predefinedThemes.length} themes available</span>
      </div>

      <div className="row g-3">
        {predefinedThemes.map((theme, index) => (
          <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3">
            <div
              className={`card rounded-4 border-2 h-100 ${
                selectedTheme === theme.id ? "border-primary shadow" : "border-light"
              } cursor-pointer`}
              onClick={() => onSelect(theme.id)}
              style={{ transition: "0.3s" }}
            >
              <div className="card-body p-3">
                <div className="d-flex gap-1 mb-3">
                  {["--color-primary-dark", "--color-primary-light", "--color-accent-yellow", "--sidebar-bg-start", "--sidebar-bg-end"].map(
                    (key, i) => (
                      <div
                        key={i}
                        style={{
                          backgroundColor: theme.colors[key],
                          width: "20%",
                          height: "26px",
                          borderRadius: "4px",
                          border: "1px solid rgba(0,0,0,0.1)",
                        }}
                      />
                    )
                  )}
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="small fw-medium">{theme.name}</span>
                  {selectedTheme === theme.id && (
                    <i className="bi bi-check-circle text-primary opacity-75"></i>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PredefinedThemesList;